import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import PrivateRoute from './components/PrivateRoute';
import BrandHead from './components/BrandHead';
import ListingView from './pages/ListingView';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Hotels from './pages/Hotels';
import HotelForm from './pages/HotelForm';
import Spas from './pages/Spas';
import SpaForm from './pages/SpaForm';
import Tours from './pages/Tours';
import TourForm from './pages/TourForm';
import TravelPackages from './pages/TravelPackages';
import TravelPackageForm from './pages/TravelPackageForm';
import OwnerRegistration from './pages/OwnerRegistration';
import OwnerPortal from './pages/OwnerPortal';
import Settings from './pages/Settings';
import Facilities from './pages/Facilities';
import FacilityForm from './pages/FacilityForm';
import Amenities from './pages/Amenities';
import AmenityForm from './pages/AmenityForm';
import HotelCategories from './pages/HotelCategories';
import HotelCategoryForm from './pages/HotelCategoryForm';
import Customers from './pages/Customers';
import CustomerForm from './pages/CustomerForm';
import Wishlists from './pages/Wishlists';
import PushNotifications from './pages/PushNotifications';
import PushNotificationForm from './pages/PushNotificationForm';
import SuggestedDestinations from './pages/SuggestedDestinations';
import SuggestedDestinationForm from './pages/SuggestedDestinationForm';
import Cities from './pages/Cities';
import VerificationSubscriptions from './pages/VerificationSubscriptions';
import VerificationSubscriptionForm from './pages/VerificationSubscriptionForm';
import FeaturedSubscriptions from './pages/FeaturedSubscriptions';
import FeaturedSubscriptionForm from './pages/FeaturedSubscriptionForm';
import SubscriptionHistory from './pages/SubscriptionHistory';
import LegalPages from './pages/LegalPages';
import LegalPageForm from './pages/LegalPageForm';
import LegalPageView from './pages/LegalPageView';
import Reports from './pages/Reports';
import OwnerRegistrations from './pages/OwnerRegistrations';
import ListingChanges from './pages/ListingChanges';
import Roles from './pages/Roles';
import RoleForm from './pages/RoleForm';
import Employees from './pages/Employees';
import EmployeeForm from './pages/EmployeeForm';
import LandingPage from './pages/LandingPage';
import { CustomerAuthProvider } from './site/CustomerAuthContext';
import ListingPage from './site/pages/ListingPage';
import StayDetailPage from './site/pages/StayDetailPage';
import SpaDetailPage from './site/pages/SpaDetailPage';
import TourDetailPage from './site/pages/TourDetailPage';
import PackageDetailPage from './site/pages/PackageDetailPage';
import WishlistPage from './site/pages/WishlistPage';
import ProfilePage from './site/pages/ProfilePage';
import LoginPage from './site/pages/LoginPage';
import HomePage from './site/pages/HomePage';
import { SITE_ENABLED } from './config/site';
import './App.css';
// Imported last so the unified page surface wins over the per-page copies
import './styles/admin-ui.css';

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <CustomerAuthProvider>
        <Router>
          {/* Keeps the tab title and favicon in step with the company branding */}
          <BrandHead />
          <Routes>
            <Route path="/sy-admin/login" element={<Login />} />
            <Route
              path="/sy-admin"
              element={
                <PrivateRoute permission="dashboard.view">
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/dashboard"
              element={
                <PrivateRoute permission="dashboard.view">
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels"
              element={
                <PrivateRoute permission="hotels.view">
                  <Hotels />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels/new"
              element={
                <PrivateRoute permission="hotels.create">
                  <HotelForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels/view/:id"
              element={
                <PrivateRoute permission="hotels.view">
                  <ListingView type="hotel" />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/hotels/edit/:id"
              element={
                <PrivateRoute permission="hotels.view">
                  <HotelForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas"
              element={
                <PrivateRoute permission="spas.view">
                  <Spas />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas/new"
              element={
                <PrivateRoute permission="spas.create">
                  <SpaForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas/view/:id"
              element={
                <PrivateRoute permission="spas.view">
                  <ListingView type="spa" />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/spas/edit/:id"
              element={
                <PrivateRoute permission="spas.view">
                  <SpaForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours"
              element={
                <PrivateRoute permission="tours.view">
                  <Tours />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours/new"
              element={
                <PrivateRoute permission="tours.create">
                  <TourForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours/view/:id"
              element={
                <PrivateRoute permission="tours.view">
                  <ListingView type="tour" />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/tours/edit/:id"
              element={
                <PrivateRoute permission="tours.view">
                  <TourForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages"
              element={
                <PrivateRoute permission="travel-packages.view">
                  <TravelPackages />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages/new"
              element={
                <PrivateRoute permission="travel-packages.create">
                  <TravelPackageForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages/view/:id"
              element={
                <PrivateRoute permission="travel-packages.view">
                  <ListingView type="travelPackage" />
                </PrivateRoute>
              }
            />
            <Route
              path="/sy-admin/travel-packages/edit/:id"
              element={
                <PrivateRoute permission="travel-packages.view">
                  <TravelPackageForm />
                </PrivateRoute>
              }
            />
          <Route path="/list-your-property" element={<OwnerRegistration />} />
          <Route path="/owner" element={<OwnerPortal />} />
          <Route path="/owner/edit/:type/:id" element={<OwnerPortal />} />
          <Route path="/owner-registration" element={<OwnerRegistration />} />
          <Route
            path="/sy-admin/settings"
            element={
              <PrivateRoute permission="settings.view">
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities"
            element={
              <PrivateRoute permission="facilities.view">
                <Facilities />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities/new"
            element={
              <PrivateRoute permission="facilities.create">
                <FacilityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/facilities/edit/:id"
            element={
              <PrivateRoute permission="facilities.view">
                <FacilityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities"
            element={
              <PrivateRoute permission="amenities.view">
                <Amenities />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities/new"
            element={
              <PrivateRoute permission="amenities.create">
                <AmenityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/amenities/edit/:id"
            element={
              <PrivateRoute permission="amenities.view">
                <AmenityForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories"
            element={
              <PrivateRoute permission="hotel-categories.view">
                <HotelCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories/new"
            element={
              <PrivateRoute permission="hotel-categories.create">
                <HotelCategoryForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/hotel-categories/edit/:id"
            element={
              <PrivateRoute permission="hotel-categories.view">
                <HotelCategoryForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/customers"
            element={
              <PrivateRoute permission="customers.view">
                <Customers />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/customers/edit/:id"
            element={
              <PrivateRoute permission="customers.view">
                <CustomerForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/wishlists"
            element={
              <PrivateRoute permission="wishlists.view">
                <Wishlists />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications"
            element={
              <PrivateRoute permission="push-notifications.view">
                <PushNotifications />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications/new"
            element={
              <PrivateRoute permission="push-notifications.create">
                <PushNotificationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/push-notifications/edit/:id"
            element={
              <PrivateRoute permission="push-notifications.view">
                <PushNotificationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations"
            element={
              <PrivateRoute permission="suggested-destinations.view">
                <SuggestedDestinations />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations/new"
            element={
              <PrivateRoute permission="suggested-destinations.create">
                <SuggestedDestinationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/suggested-destinations/edit/:id"
            element={
              <PrivateRoute permission="suggested-destinations.view">
                <SuggestedDestinationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/cities"
            element={
              <PrivateRoute permission="cities.view">
                <Cities />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions"
            element={
              <PrivateRoute permission="verification-subscriptions.view">
                <VerificationSubscriptions />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions/new"
            element={
              <PrivateRoute permission="verification-subscriptions.create">
                <VerificationSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/verification-subscriptions/edit/:id"
            element={
              <PrivateRoute permission="verification-subscriptions.view">
                <VerificationSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions"
            element={
              <PrivateRoute permission="featured-subscriptions.view">
                <FeaturedSubscriptions />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions/new"
            element={
              <PrivateRoute permission="featured-subscriptions.create">
                <FeaturedSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/featured-subscriptions/edit/:id"
            element={
              <PrivateRoute permission="featured-subscriptions.view">
                <FeaturedSubscriptionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/subscription-history"
            element={
              <PrivateRoute permission="subscription-history.view">
                <SubscriptionHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/reports"
            element={
              <PrivateRoute permission="reports.view">
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages"
            element={
              <PrivateRoute permission="legal-pages.view">
                <LegalPages />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages/new"
            element={
              <PrivateRoute permission="legal-pages.create">
                <LegalPageForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/legal-pages/edit/:id"
            element={
              <PrivateRoute permission="legal-pages.view">
                <LegalPageForm />
              </PrivateRoute>
            }
          />
          {/* Public legal page view */}
          <Route
            path="/sy-admin/owner-registrations"
            element={
              <PrivateRoute permission="owner-registrations.view">
                <OwnerRegistrations />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/listing-changes"
            element={
              <PrivateRoute permission="listing-changes.view">
                <ListingChanges />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/roles"
            element={
              <PrivateRoute permission="roles.view">
                <Roles />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/roles/new"
            element={
              <PrivateRoute permission="roles.create">
                <RoleForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/roles/edit/:id"
            element={
              <PrivateRoute permission="roles.view">
                <RoleForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/employees"
            element={
              <PrivateRoute permission="employees.view">
                <Employees />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/employees/new"
            element={
              <PrivateRoute permission="employees.create">
                <EmployeeForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/sy-admin/employees/edit/:id"
            element={
              <PrivateRoute permission="employees.view">
                <EmployeeForm />
              </PrivateRoute>
            }
          />
          <Route path="/page/:slug" element={<LegalPageView />} />
          {/* Landing page, or the website home page once the website is switched on */}
          <Route path="/" element={SITE_ENABLED ? <HomePage /> : <LandingPage />} />
          {/* Customer website: the app's features in the browser (see config/site.js) */}
          {SITE_ENABLED && (
            <>
              <Route path="/stays" element={<ListingPage kind="stays" />} />
              <Route path="/stays/:id" element={<StayDetailPage />} />
              <Route path="/spas" element={<ListingPage kind="spas" />} />
              <Route path="/spas/:id" element={<SpaDetailPage />} />
              <Route path="/tours" element={<ListingPage kind="tours" />} />
              <Route path="/tours/:id" element={<TourDetailPage />} />
              <Route path="/packages" element={<ListingPage kind="packages" />} />
              <Route path="/packages/:id" element={<PackageDetailPage />} />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/login" element={<LoginPage />} />
            </>
          )}
          {/* Redirect unknown admin routes to admin dashboard */}
          <Route path="/sy-admin/*" element={<Navigate to="/sy-admin" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        </CustomerAuthProvider>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;

